// Constants cho Dashboard
export const DASHBOARD_CONSTANTS = {
  // Style constants
  STYLES: {
    CARD: {
      textAlign: 'center' as const,
      fontWeight: 600,
      height: '100%'
    },
    CARD_LABEL: {
      fontSize: 12,
      color: '#666'
    },
    CARD_VALUE: {
      fontSize: 24,
      marginBottom: 4
    },
    COLORS: {
      SUCCESS: '#52c41a',
      WARNING: '#faad14',
      ERROR: '#ff4d4f',
      INFO: '#1890ff',
      DISPOSED: '#bfbfbf'
    }
  },

  // Status types
  STATUS: {
    OVERDUE: 'overdue',
    SOON_DUE_7: 'soon_due_7',
    SOON_DUE_30: 'soon_due_30',
    UPCOMING: 'upcoming'
  },

  // Alert types
  ALERT_TYPES: {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info'
  },

  // Messages
  MESSAGES: {
    NO_OVERDUE_MAINTENANCE: 'Không có lịch bảo dưỡng quá hạn',
    NO_SOON_DUE_7_MAINTENANCE: 'Không có lịch bảo dưỡng sắp tới hạn 7 ngày',
    NO_SOON_DUE_30_MAINTENANCE: 'Không có lịch bảo dưỡng sắp tới hạn 30 ngày',
    NO_OVERDUE_AUDIT: 'Không có tài sản kiểm kê quá hạn',
    NO_SOON_AUDIT_7: 'Không có tài sản kiểm kê sắp tới hạn 7 ngày',
    NO_SOON_AUDIT_30: 'Không có tài sản kiểm kê sắp tới hạn 30 ngày',
    LOAD_ERROR: 'Không thể load dashboard data',
    HAS_OVERDUE_MAINTENANCE: (count: number) => `Có ${count} lịch bảo dưỡng quá hạn`,
    HAS_SOON_DUE_7_MAINTENANCE: (count: number) => `Có ${count} lịch bảo dưỡng sắp tới hạn (7 ngày)`,
    HAS_SOON_DUE_30_MAINTENANCE: (count: number) => `Có ${count} lịch bảo dưỡng sắp tới hạn (30 ngày)`,
    HAS_OVERDUE_AUDIT: (count: number) => `Có ${count} tài sản kiểm kê đã quá hạn`,
    HAS_SOON_AUDIT_7: (count: number) => `Có ${count} tài sản kiểm kê sắp tới hạn (7 ngày)`,
    HAS_SOON_AUDIT_30: (count: number) => `Có ${count} tài sản kiểm kê sắp tới hạn (30 ngày)`
  },

  // Labels
  LABELS: {
    TOTAL_ASSETS: 'Tổng số tài sản',
    TOTAL_VALUE: 'Tổng giá trị VNĐ',
    DISPOSED: 'Đã thanh lý',
    IN_USE: 'Đang sử dụng'
  }
};

// Types cho Dashboard
export interface DashboardData {
  overdueMaintenances: MaintenanceSchedule[];
  soonMaintenances7: MaintenanceSchedule[];
  soonMaintenances30: MaintenanceSchedule[];
  overdueAudits: AssetAudit[];
  soonAudits7: AssetAudit[];
  soonAudits30: AssetAudit[];
  summary: AssetSummary;
  companyStats: CompanyStats[];
  companyAssetStats: CompanyAssetStats[];
  companyDisposedStats: CompanyDisposedStats[];
  assetStatusByCompany: AssetStatusByCompany[];
}

export interface MaintenanceSchedule {
  id: number;
  asset_id: number;
  asset_code: string;
  asset_name: string;
  company_id: number;
  next_due_date: string;
  maintenance_type_name?: string;
}

export interface AssetAudit {
  id: number;
  asset_code: string;
  name: string;
  company_id: number;
  next_audit_due: string;
}

export interface AssetSummary {
  total_assets: number;
  total_value: number;
  disposed_count: number;
  in_use_count: number;
}

export interface CompanyStats {
  company_id: number;
  company_name: string;
  total_assets: number;
  total_value: number;
}

export interface CompanyAssetStats {
  company_id: number;
  company_name: string;
  total_assets: number;
  total_value: number;
}

export interface CompanyDisposedStats {
  company_id: number;
  disposed_count: number;
}

export interface AssetStatusByCompany {
  company_id: number;
  status: string;
  count: number;
} 